export default __webpack_public_path__ + "static/media/grey-clock-arrow.6e47664d.png";